const noticeData = [
    {
        no: "1",
        title: "드림티원 사이트가 오픈되었습니다",
        date: "2025.07.24",
        name: "작성자",
        text: `
        <br/> 드림티원 사이트가 오픈되었습니다.
        <br/> - 드림티원 얼굴인식 기반 인증 기술을 통해 미래형 신뢰 시스템을 구축하고,<br/>
        <br/> - 개인과 조직의 일상적인 인증 과정을 혁신합니다.!<br/>
        <br/>
        `,
    },
];

export default noticeData;

